import { category } from '../config'

const order = array => {
  try {
    const categories = {}
    array.forEach(elemnt => {
      const currentCategoryName = elemnt.category
      const currentCategory = categories[currentCategoryName] || []
      categories[currentCategoryName] = [...currentCategory, elemnt]
    })
    var ArrayOrdered = []
    Object.keys(category).forEach(keyname => {
      if (categories[keyname]) {
        ArrayOrdered = [...ArrayOrdered, ...categories[keyname]]
      }
    })
    console.log('ArrayOrdered', ArrayOrdered.map(item => console.log(item.category)))
    return ArrayOrdered
  } catch (error) {
    console.log('__error_al_ordenar__', error)
    return array
  }
}

export default order
